module.exports = __webpack_public_path__ + "static/media/head.fe4096a3.png";